<template>
  <span
    :style="styleVars"
    :class="[
      $style.avatarContainer,
      $style[sizeClass],
      border ? $style.withBorder : '',
      customSize ? $style.isCustomSize : '',
    ]"
  >
    <img
      v-if="src"
      :class="[
        $style.avatarImg,
        noInsetBorder ? $style.avatarImgNoInset : '',
      ]"
      :src="src"
      alt=""
    >
    <span
      v-else-if="resourcePage"
      :class="$style.defaultResourceIcon"
      v-html="defaultResourceAva"
    />
    <span
      v-else
      :class="$style.defaultIcon"
      v-html="defaultAva"
    />
  </span>
</template>

<script>
import defaultAva from './defaultAva.svg';
import defaultResourceAva from './defaultResourceAva.svg';

export default {
  name: 'VgpAvatar',
  props: {
    src: {
      type: String,
      default: null,
    },
    resourcePage: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    border: {
      type: Boolean,
      required: false,
      default: false,
    },
    customSize: {
      type: [Number, String],
      required: false,
      default: '',
    },
    noInsetBorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultAva,
      defaultResourceAva,
    };
  },
  computed: {
    sizeClass() {
      if (this.size === 'small') return 'sizeSmall';
      if (this.size === 'large') return 'sizeLarge';

      return 'sizeMedium';
    },

    styleVars() {
      if (!this.customSize) return null;

      return {
        '--vgp-avatar-size': `${this.customSize}px`,
      };
    },
  },
};
</script>

<style module lang="less" src="./vgpAvatar.less"></style>
